import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { StyleObject } from '../types/types';
import { setBodyStyleObject } from '../util/util';

/**
 * StyleProvider root component
 */
@customElement('style-provider')
export class StyleProvider extends LitElement {
  private readonly styleObject: StyleObject = {
    // Color styles
    '--primary-color': '#014E2A',
    '--primary-hover-color': '#026E3C',
    '--background-color': 'white',
    '--background-color-hover': '#E6F5EC',
    '--menu-color': '#014E2A',
    '--dark-background-color': 'black',

    // Grey-ish
    '--text-color-main': '#2e2c2c',
    '--text-color-light': 'white',
  };

  constructor() {
    super();
    setBodyStyleObject(this.styleObject);
  }

  /**
   * Render function
   */
  public render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'style-provider': StyleProvider;
  }
}
